import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
//引入icon图标
import './assets/font_quirk/iconfont.css'
import './assets/font_quirk/iconfont.js'
import './assets/iconfont/iconfont.css'
import './assets/iconfont/iconfont.js'
import 'echarts-gl';
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$echarts = echarts

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
